import { ExpandMore } from '@mui/icons-material';
import { AccordionDetails, Typography } from '@mui/material';
import { Accordion } from '@mui/material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Grid } from '@mui/material';
import { memo, useState } from 'react';
import Form from './form';
import { DataDeclarationVM } from 'civil-status/view-models/form-declaration-icaro';
import { FormikErrors, FormikTouched } from 'formik';

interface DataDeclarationProps {
  disabled?: boolean;
  values?: DataDeclarationVM;
  errors?: FormikErrors<DataDeclarationVM>;
  touched?: FormikTouched<DataDeclarationVM>;
  onChange: (
    key: keyof DataDeclarationVM,
    value: DataDeclarationVM[keyof DataDeclarationVM]
  ) => void;
  isRejectionState?: boolean;
}
const DataDeclarationComponent = ({
  disabled,
  values,
  errors,
  touched,
  onChange,
  isRejectionState,
}: DataDeclarationProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls={`panel-data-declaration-content`}
        id={`panel-data-declaration-header`}
        expandIcon={<ExpandMore />}
      >
        <Typography style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          Dati dichiarazione ICARO
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {open ? (
          <Grid item container spacing={2}>
            <Form
              disabled={disabled}
              values={values}
              errors={errors}
              touched={touched}
              onChange={onChange}
              isRejectionState={isRejectionState}
            />
          </Grid>
        ) : undefined}
      </AccordionDetails>
    </Accordion>
  );
};

DataDeclarationComponent.displayName = 'Data Declaration Component';

const DataDeclaration = memo(DataDeclarationComponent);

export default DataDeclaration;
